<template>
  <component
    :is="tag"
    class="dropdown"
    :class="{ show: isOpen }"
    @click.stop="toggleDropDown"
  >
    <a
      class="dropdown-toggle btn-rotate"
      :class="titleClasses"
      data-toggle="dropdown"
    >
      <slot name="title" style="display: flex; align-items: center">
        <span v-if="icon">
          <i :class="icon"></i>
        </span>
        <span v-else-if="image">
          <img :src="image" alt="image" class="icon_image" />
        </span>

        <span class="notification">
          {{ title }}
          <b class="caret"></b>
        </span>
      </slot>
    </a>
    <ul
      class="dropdown-menu"
      :class="{ show: isOpen }"
      v-if="isOpen"
      @click.stop
    >
      <slot></slot>
    </ul>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "li",
    },
    title: String,
    icon: String,
    image: {
      type: String,
      default: null,
    },
    titleClasses: [String, Object, Array],
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleDropDown() {
      this.$emit("change");
    },
  },
};
</script>

<style scoped>
.dropdown-link:hover {
  background-color: #23282d;
}

.icon_image {
  font-size: 24px;
  float: left;
  margin-right: 15px;
  line-height: 30px;
  width: 30px;
  text-align: center;
}
</style>
